import Vue from 'vue'
import Vuex from 'vuex'
import socket from './modules/socket'
import chat from './modules/chat'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    socket: socket,
    chat: chat
  },
  strict: debug
})
